import { lazy, Suspense } from "react";

import { Routes, Route } from "react-router-dom";

import Spinner from "./components/Spinner";

const Home = lazy(() => import("./pages/Home/Home"));
const One = lazy(() => import("./pages/1/1"));
const Two = lazy(() => import("./pages/2/2"));
const Three = lazy(() => import("./pages/3/3"));
const Four = lazy(() => import("./pages/4/4"));
const Five = lazy(() => import("./pages/5/5"));
const Six = lazy(() => import("./pages/6/6"));
const Seven = lazy(() => import("./pages/7/7"));
const Eight = lazy(() => import("./pages/8/8"));
const Nine = lazy(() => import("./pages/9/9"));
const Ten = lazy(() => import("./pages/10/10"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));

export default function RoutesContainer() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/1" element={<One />} />
        <Route path="/2" element={<Two />} />
        <Route path="/3" element={<Three />} />
        <Route path="/4" element={<Four />} />
        <Route path="/5" element={<Five />} />
        <Route path="/6" element={<Six />} />
        <Route path="/7" element={<Seven />} />
        <Route path="/8" element={<Eight />} />
        <Route path="/9" element={<Nine />} />
        <Route path="/10" element={<Ten />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
